var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 176,
    viewBox: "0 0 1440 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1514.41 158.07C1902.25 477.764 1499.43 418.894 1540.86 459.956C1626.92 586.727 1640.48 682.919 1643.96 689.839C1648.31 698.489 1001.58 787.105 987.849 786.224C976.867 785.518 222.793 803.462 -152.872 812.522C-261.634 615.259 -184.851 349.09 -184.851 349.09C-184.851 349.09 -681.116 -159.713 4.94285 52.5405C853.562 315.087 1149.76 -142.517 1514.41 158.07Z",
    fill: "#4B5E7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg10);
export default __webpack_public_path__ + "static/media/bg-10.3c646032a378cd23f2499936d5de8011.svg";
export { ForwardRef as ReactComponent };